import PopoverContent from './PopoverContent'
import PopoverRoot from './PopoverRoot'
import PopoverTrigger from './PopoverTrigger'

export const PopoverHover = {
  PopoverRoot,
  PopoverContent,
  PopoverTrigger,
}
